import {
  GetPillarColorFragment,
  MaturityLevel,
  PriorityLevel,
  ThemeColor,
} from '@/graphql/generated';

export function getPillarColor(
  pillar: GetPillarColorFragment | null | undefined,
): string {
  return getThemeLightColor(pillar?.color);
}

export function getThemeLightColor(
  themeColor: ThemeColor | null | undefined,
): string {
  switch (themeColor) {
    case ThemeColor.Gray:
      return 'bg-gray-50';
    case ThemeColor.Green:
      return 'bg-green-50';
    case ThemeColor.Purple:
      return 'bg-purple-50';
    case ThemeColor.Blue:
      return 'bg-blue-50';
    case ThemeColor.Red:
      return 'bg-red-50';
    case ThemeColor.Yellow:
      return 'bg-yellow-50';
    default:
      return 'bg-gray-50';
  }
}

export function getMaturityLevelFromComputedValue(
  computedValue: number | null | undefined,
): MaturityLevel | null {
  if (typeof computedValue !== 'number' || computedValue < 0) {
    return null;
  }

  if (computedValue > 3) {
    return MaturityLevel.High;
  }
  if (computedValue > 2) {
    return MaturityLevel.Medium;
  }
  if (computedValue > 1) {
    return MaturityLevel.Low;
  }
  return MaturityLevel.None;
}

export function getPriorityLevelFromComputedValue(
  computedValue: number,
): PriorityLevel | null {
  if (computedValue < 0) {
    return null;
  }

  if (computedValue > 3) {
    return PriorityLevel.High;
  }
  if (computedValue > 2) {
    return PriorityLevel.Medium;
  }
  if (computedValue > 1) {
    return PriorityLevel.Low;
  }
  return PriorityLevel.None;
}

/**
 * Utility function to extract materiality scores from a stake object.
 * Returns persisted scores if available, otherwise computed scores, otherwise 0.
 *
 * @param stake - Stake object with persisted and computed materiality score fields
 * @returns Object with impactMaterialityScore and financialMaterialityScore
 */
export function getPersistedOrComputedMaterialityScore(stake: {
  persistedImpactMaterialityScore?: number | null;
  computedImpactMaterialityScore?: number | null;
  persistedFinancialMaterialityScore?: number | null;
  computedFinancialMaterialityScore?: number | null;
}): {
  impactMaterialityScore: number;
  financialMaterialityScore: number;
} {
  return {
    impactMaterialityScore:
      stake.persistedImpactMaterialityScore ??
      stake.computedImpactMaterialityScore ??
      0,
    financialMaterialityScore:
      stake.persistedFinancialMaterialityScore ??
      stake.computedFinancialMaterialityScore ??
      0,
  };
}
